module.exports = __webpack_public_path__ + "static/14-kim-0f419de5a70920b73c8e1e68605fbdb6.jpg";